<template>
<div class="clubPhilosophy">
  <section class="clubPhilosophy__left">

    <svg class="clubPhilosophy__icon" width="43" height="23" viewBox="0 0 43 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3207 0H0.991061C0.442812 0 0 0.442826 0 0.991075V10.3207C0 10.8689 0.442812 11.3117 0.991061 11.3117H10.3207C10.8689 11.3117 11.3117 10.8689 11.3117 10.3207V0.991075C11.3117 0.442826 10.8689 0 10.3207 0Z" fill="white" fill-opacity="0.7"/>
      <path d="M31.4654 0H22.1452C21.5946 0 21.1494 0.445159 21.1494 0.995751V10.316C21.1494 10.8666 21.5946 11.3117 22.1452 11.3117H31.4654C32.016 11.3117 32.4612 10.8666 32.4612 10.316V0.995751C32.4612 0.445159 32.016 0 31.4654 0Z" fill="white" fill-opacity="0.7"/>
      <path d="M20.9091 10.8455H11.6311C11.0688 10.8455 10.6143 11.3 10.6143 11.8623V21.1404C10.6143 21.7027 11.0688 22.1572 11.6311 22.1572H20.9091C21.4714 22.1572 21.926 21.7027 21.926 21.1404V11.8623C21.926 11.3 21.4714 10.8455 20.9091 10.8455Z" fill="white" fill-opacity="0.7"/>
      <path d="M41.9998 10.8455H32.6889C32.136 10.8455 31.6885 11.293 31.6885 11.8459V21.1568C31.6885 21.7097 32.136 22.1572 32.6889 22.1572H41.9998C42.5527 22.1572 43.0002 21.7097 43.0002 21.1568V11.8459C43.0002 11.293 42.5527 10.8455 41.9998 10.8455Z" fill="white" fill-opacity="0.7"/>
    </svg>


    <div class="clubPhilosophy__text">
      <strong>
      Философия Кибердеда — умение видеть систему в хаосе,
      </strong>
      осмысленно относиться к цифровому миру и развивать навыки, которые помогают не только в работе, но и в жизни.
    </div>
    <div class="clubPhilosophy__buttons">
      <ActionButton
          v-if="!settings.user.is_at_club"
          style="background-color: #6FC062; color: #212226; padding: 30px 20px"
          @buttonClick="$router.push({name: 'ClubSignUpView'})"
      >
        <template #caption>Вступить в клуб</template>
      </ActionButton>
    </div>
  </section>
  <section class="clubPhilosophy__right">
    <img class="clubPhilosophy__img" :src="require('@/assets/img/club-philosophy.png')">
  </section>
</div>
</template>

<script>
import ActionButton from "@/components/ui/ActionButton.vue";
import {useSettingsStore} from "@/store/settings";

export default {
  name: "ClubPhilosophy" ,
  components: {ActionButton},
  setup() {
    const settings = useSettingsStore();
    return {settings}
  }
}
</script>


<style scoped lang="scss">
.clubPhilosophy {
  display: flex;
  gap: 20px;
  text-align: left;

  @include respond-to('md') { flex-direction: column; }

  &__left {
    position: relative;
    padding: 40px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    background: var(--cd-card-bg);
    border-radius: 20px;
    flex: 1 1 400px;
  }

  &__text {
    font-size: clamp(18px, 3vw, 28px);
    font-family: var(--cd-bold-font);
    font-weight: 500;
    max-width: 574px;
    width: 100%;
    color: var(--cd-text-muted);

    strong { color: var(--cd-highlight-text); }
  }

  &__buttons {
    margin-top: auto;
  }

  &__right {
    flex: 1 1 300px;

    img {
      width: 100%;
      height: auto;
      border-radius: var(--cd-card-border-radius);
      object-fit: cover;
    }
  }
}
</style>
